import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center bg-gray-100" }
const _hoisted_2 = { class: "bg-white shadow-lg rounded-xl p-10 max-w-md w-full text-center ani-top" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl font-bold mb-4 text-green-600" }, "Thank you!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 mb-6" }, "We’ve received your message and will get back to you soon.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: "/",
        class: "inline-block bg-gray-800 text-white px-6 py-3 rounded hover:bg-gray-700 transition"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Back to home ")
        ]),
        _: 1
      })
    ])
  ]))
}